import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=f7377604&scoped=true"
import script from "./Window.vue?vue&type=script&lang=js"
export * from "./Window.vue?vue&type=script&lang=js"
import style0 from "./Window.vue?vue&type=style&index=0&id=f7377604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7377604",
  null
  
)

export default component.exports